import { DepartmentParams } from './types';

export const departmentKeys = {
  all: () => ['MANAGED_DEPARTMENTS'],
  managed: (params?: DepartmentParams) =>
    ['MANAGED_DEPARTMENTS', params] as const,
};
